// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CorePricingVm from "../../../vm-mapper/CorePricingVm.bs.js";
import * as CustomSidebar from "../../../library/reuseable-components/CustomSidebar.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CorePricingContext from "../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as CorePricingDetails from "./CorePricingDetails.bs.js";
import * as ModificationsTabView from "./pricing-modification/ModificationsTabView.bs.js";
import * as CorePricingSidebarStore from "./CorePricingSidebarStore.bs.js";
import * as CloseSidebarConfirmationModal from "./CloseSidebarConfirmationModal.bs.js";

function getCountOfModifications(modifications) {
  switch (modifications.TAG | 0) {
    case /* Live */1 :
        return List.length(modifications._0);
    case /* Loading */0 :
    case /* Error */2 :
        return 0;
    
  }
}

function pendingModificationsExist(modifications) {
  switch (modifications.TAG | 0) {
    case /* Live */1 :
        return List.exists((function (a) {
                      return a.key_details.status === /* Pending */0;
                    }), modifications._0);
    case /* Loading */0 :
    case /* Error */2 :
        return false;
    
  }
}

function showWarningModal(modified_priorities, edited_modifications) {
  if (List.length(modified_priorities) !== 0) {
    return true;
  } else {
    return Object.keys(edited_modifications).length !== 0;
  }
}

function CorePricingDetailSidebar(Props) {
  var campaign = Props.campaign;
  var role = Props.role;
  var closeSidebar = Props.closeSidebar;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = CorePricingContext.useContext(undefined);
  var match$2 = match$1.geo_region;
  var geo_region_id = match$2.geo_region_id;
  var campaign$1 = CorePricingVm.getVm(campaign, match$1.vehicle_type.vehicle_name, match$2.geo_region_name);
  var match$3 = React.useState(function () {
        return /* COREPRICING */0;
      });
  var toggleTab = match$3[1];
  var activeTab = match$3[0];
  var match$4 = React.useState(function () {
        return /* ApprovedPriorities */0;
      });
  var toggleModificationTab = match$4[1];
  var match$5 = React.useState(function () {
        return [
                false,
                (function (param) {
                    
                  })
              ];
      });
  var toggelConfirmationModal = match$5[1];
  var open_confirmation_modal = match$5[0];
  var match$6 = React.useReducer((function (state, action) {
          return CorePricingSidebarStore.reducer(action, state);
        }), CorePricingSidebarStore.getInitialState(undefined));
  var dispatch = match$6[1];
  var state = match$6[0];
  React.useEffect((function () {
          CorePricingSidebarStore.fetchModifications(campaign$1.campaign_id, dispatch)(country);
          CorePricingSidebarStore.fetchZones(geo_region_id, dispatch)(country);
          CorePricingSidebarStore.fetchClusters(geo_region_id, dispatch)(country);
          
        }), []);
  var refetchModifications = function (param) {
    Curry._1(dispatch, {
          TAG: /* SetModifications */0,
          _0: {
            TAG: /* Loading */0,
            _0: undefined
          }
        });
    return CorePricingSidebarStore.fetchModifications(campaign$1.campaign_id, dispatch)(country);
  };
  var c = getCountOfModifications(state.modifications);
  var tmp;
  if (open_confirmation_modal[0]) {
    var cb = open_confirmation_modal[1];
    tmp = React.createElement(CloseSidebarConfirmationModal.make, {
          isOpen: true,
          onConfirmCb: (function (param) {
              Curry._1(cb, undefined);
              return Curry._1(toggelConfirmationModal, (function (param) {
                            return [
                                    false,
                                    (function (param) {
                                        
                                      })
                                  ];
                          }));
            }),
          onCancelCb: (function (param) {
              return Curry._1(toggelConfirmationModal, (function (param) {
                            return [
                                    false,
                                    (function (param) {
                                        
                                      })
                                  ];
                          }));
            })
        });
  } else {
    tmp = null;
  }
  return React.createElement(CustomSidebar.make, {
              is_open: true,
              on_back_drop_click: showWarningModal(state.modified_priorities, state.edited_modifications) ? (function (param) {
                    return Curry._1(toggelConfirmationModal, (function (param) {
                                  return [
                                          true,
                                          closeSidebar
                                        ];
                                }));
                  }) : closeSidebar,
              children: null
            }, React.createElement("div", {
                  className: "c-campaign-details-header"
                }, campaign$1.campaign_name), React.createElement("div", {
                  className: "c-campaign-details-body"
                }, React.createElement(Row$Catalyst.make, {
                      children: React.createElement("div", {
                            className: "btn-wrapper"
                          }, React.createElement("div", {
                                className: "core-pricing-btn " + (
                                  activeTab === /* COREPRICING */0 ? "selected" : ""
                                ),
                                onClick: (function (param) {
                                    if (showWarningModal(state.modified_priorities, state.edited_modifications)) {
                                      return Curry._1(toggelConfirmationModal, (function (param) {
                                                    return [
                                                            true,
                                                            (function (param) {
                                                                Curry._1(toggleTab, (function (param) {
                                                                        return /* COREPRICING */0;
                                                                      }));
                                                                return Curry._1(dispatch, /* ResetModification */0);
                                                              })
                                                          ];
                                                  }));
                                    } else {
                                      return Curry._1(toggleTab, (function (param) {
                                                    return /* COREPRICING */0;
                                                  }));
                                    }
                                  })
                              }, "CORE PRICING"), React.createElement("div", {
                                className: "modifications-btn " + (
                                  activeTab === /* MODIFICATION */1 ? "selected" : ""
                                ),
                                onClick: (function (param) {
                                    return Curry._1(toggleTab, (function (param) {
                                                  return /* MODIFICATION */1;
                                                }));
                                  })
                              }, React.createElement(Row$Catalyst.make, {
                                    children: c !== 0 ? React.createElement(React.Fragment, undefined, pendingModificationsExist(state.modifications) ? React.createElement("div", {
                                                  className: "pending-modifications-indicator"
                                                }) : null, "MODIFICATIONS ( " + (String(c) + " ) ")) : "MODIFICATIONS"
                                  }))),
                      className: "c-core-pricing-toggle-btn"
                    }), activeTab ? React.createElement(ModificationsTabView.make, {
                        core_pricing: campaign$1,
                        modifications: state.modifications,
                        zones: state.zones,
                        clusters: state.clusters,
                        refetchModifications: refetchModifications,
                        modified_priorities: state.modified_priorities,
                        initial_priorities: state.initial_priorities,
                        edited_modifications: state.edited_modifications,
                        dispatch: dispatch,
                        active_tab: match$4[0],
                        toggleModificationTab: (function (tab) {
                            if (showWarningModal(state.modified_priorities, state.edited_modifications)) {
                              return Curry._1(toggelConfirmationModal, (function (param) {
                                            return [
                                                    true,
                                                    (function (param) {
                                                        Curry._1(toggleModificationTab, tab);
                                                        return Curry._1(dispatch, /* ResetModification */0);
                                                      })
                                                  ];
                                          }));
                            } else {
                              return Curry._1(toggleModificationTab, tab);
                            }
                          })
                      }) : React.createElement(CorePricingDetails.make, {
                        campaign: campaign$1,
                        role: role,
                        closeSidebar: closeSidebar
                      })), tmp);
}

var make = CorePricingDetailSidebar;

export {
  getCountOfModifications ,
  pendingModificationsExist ,
  showWarningModal ,
  make ,
  
}
/* react Not a pure module */
